/* src/app/pages/user/details/details.component.scss */
table {
  width: 100%;
}
/*# sourceMappingURL=details.component.css.map */
